import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { fbq } from "../../fbq";
const signupSlice = createSlice({
  name: "signup",
  initialState: {
    token: localStorage.getItem("acs") || null,
    otp: !!localStorage.getItem("acs"),
    loading: false,
    error: null,
  },

  reducers: {
    signupStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    signupSuccess: (state, action) => {
      state.loading = false;
      state.otp = true;
      state.token = action.payload; // Save the OTP token
    },
    signupFailure: (state, action) => {
      state.loading = false;
      state.otp = false;
      state.error = action.payload;
    },
    resetSignupState: (state) => {
      state.token = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { signupStart, signupSuccess, signupFailure, resetSignupState } =
  signupSlice.actions;

export default signupSlice.reducer;

export const SignUp = (data, navigate) => async (dispatch) => {
  try {
    dispatch(signupStart());

    const response = await axios.post("/public/signup", data);

    if (response?.status === 200) {
      const data = response.data;
      dispatch(signupSuccess(data.token));
      localStorage.setItem("acs", data.token);
      toast.success("Please verify your OTP!!");
      // Fire LEAD when signup form accepted and OTP sent
      fbq("track", "Lead", {
        content_name: "Signup OTP Sent",
        status: "otp_sent",
        value: 0,
        currency: "USD",
        email: data?.email ?? undefined,
      });
    }
  } catch (err) {
    // Handle errors
    toast.error(err?.response?.data?.message || err.message || "Login failed!");
    dispatch(
      signupFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};
